import { render, staticRenderFns } from "./FileDownloadField.vue?vue&type=template&id=70a4e6e5&scoped=true"
import script from "./FileDownloadField.vue?vue&type=script&lang=js"
export * from "./FileDownloadField.vue?vue&type=script&lang=js"
import style0 from "./FileDownloadField.vue?vue&type=style&index=0&id=70a4e6e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a4e6e5",
  null
  
)

export default component.exports